import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { editProfile, getCurrentUser } from "store/actions";
import Loader from "components/shared/loader";
import ImageUpload from "components/shared/ImageUpload";
import { cutImageFullPath } from "helpers/functions";
import Form from "components/Form";
import FormWrapper from "components/Form/FormWrapper";
import Input from "components/Form/Input";
import SaveChangesButton from "components/Form/SaveChangesButton";

const ViewEditProfile = () => {
    const dispatch = useDispatch();

    const {
        authentication: { user, loading },
    } = useSelector((state) => state);

    const [selectedImage, setSelectedImage] = useState({});

    useEffect(() => {
        dispatch(getCurrentUser());
        setSelectedImage({ path: user.image });
    }, [dispatch]);

    const defaultValues = {
        name: user?.name,
        email: user?.email,
        phone: user?.phone,
    };

    const onSubmit = (data) => {
        if (data?.email === user?.email) delete data.email;
        if (data?.phone === user?.phone) delete data.phone;

        data.image = cutImageFullPath(selectedImage?.path);

        dispatch(editProfile({ data }));
    };

    if (loading) return <Loader />;

    return (
        <FormWrapper title="editProfile" lg={12}>
            <div className="card-body">
                <Row>
                    <ImageUpload
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                    />
                </Row>
                <Form onSubmit={onSubmit} defaultValues={defaultValues}>
                    <Col xl={8} md={12}>
                        <Row>
                            <Input name="name" />
                            <Input type="number" name="phone" />
                            <Input type="email" name="email" />

                            <SaveChangesButton />
                        </Row>
                    </Col>
                </Form>
            </div>
        </FormWrapper>
    );
};

export default ViewEditProfile;
